import { looseEqual } from "../../../utils";
import { formMixin, formRadioCheckMixin } from "../../../mixins";

export default {
  prop: {
    label: String
  },

  mixins: [formMixin, formRadioCheckMixin],

  render(h) {
    const t = this;
    const $slots = t.$slots;
    const input = h("input", {
      ref: "radio",
      class: ["m-r-10"],
      attrs: {
        type: "radio",
        name: t.name,
        required: t.required,
        disabled: t.disabled,
        autocomplete: "off"
      },
      domProps: {
        value: t.value,
        checked: t.computedLocalChecked
          ? t.computedLocalChecked.id == t.value.id
          : false
      },
      on: {
        change: t.emitChange,
        __c: evt => {
          t.computedLocalChecked = t.value;
        }
      }
    });

    var linkToPassenger = h(
      "a",
      {
        class: ["pull-right"],
        attrs: {
          href: "/passenger/details/" + this.value.id,
          target: "_blank"
        }
      },
      ["More info ", h("i", { class: ["fa", "fa-external-link"] })]
    );

    return h(
      "div",
      {
        class: ["alert", "alert-outer-light-white"],
        on: {
          click: t.handleClick
        }
      },
      [
        h(
          "label",
          {
            class: ["full-width"]
          },
          [$slots.first, input, this.label, linkToPassenger]
        )
      ]
    );
  },

  watch: {
    // Radio Groups can only have a single value, so our watchers are simple
    checked(newVal, oldVal) {
      this.computedLocalChecked = newVal;
    },
    computedLocalChceked(newVal, oldVal) {
      this.$emit("input", this.computedLocalChceked);
    }
  },
  computed: {
    is_Checked() {
      return this.computedLocalChecked
        ? this.computedLocalChecked.id == this.value.id
        : false;
    }
  },

  methods: {
    handleClick(event) {
      this.computedLocalChecked = this.value;
    },

    emitChange({ target: { checked } }) {
      // Change is only emitted on user interaction
      this.$emit("change", checked ? this.value : null);
      // If this is a child of form-radio-group, we emit a change event on it as well
      if (this.is_Child) {
        this.$parent.$emit("change", this.computedLocalChecked);
      }
    }
  }
};
